import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './GoogleCallback.css';

axios.defaults.withCredentials = true;

const GoogleCallback = () => {

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the authorization code from URL parameters
        // const urlParams = new URLSearchParams(window.location.search);

        // Make API call to backend for token exchange
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/auth/google/callback`);
        return response.json();

      } catch (error) {
        console.error('Authentication error:', error);
      }
    };

    handleCallback();
  }, []); // Empty dependency array means this runs once when component mounts

  return (
    <div className="callback-container">
      <div className="loading-spinner">
        <p>Authenticating...</p>
      </div>
    </div>
  );
};

export default GoogleCallback;

